"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MenuItemMixin = require("../../mixins/components/MenuItemMixin");
var StyledMenuItem = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "StyledMenuItem",
  componentId: "c11n-8-107-0__sc-1flhz79-0"
})(["", ""], _MenuItemMixin.MenuItemMixin);
exports.StyledMenuItem = StyledMenuItem;